/* eslint-disable no-unused-vars */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'lodash';

import t from '../../lib/I18n';
import config from '../../config';
import connectToStores from '../../helpers/connectToStores';
import FormattedHTMLMessage from '../general/FormattedHTMLMessage';
import HelpIcon from '../../components/general/HelpIcon';
import Icon from '../../components/general/Icon';
import User from '../../records/User';
import AccountRailcard from '../../records/AccountRailcard';
import ToggleInput from '../../components/form/ToggleInput';
import Railcard1617Actions from '../../actions/Railcard1617Actions';
import Railcard1617Store from '../../stores/Railcard1617Store';

const getStateFromStores = () => {
    return {
        checked: Railcard1617Store.get('checked'),
        railcard1617: Railcard1617Store.getRailcard()
    };
};

class Railcard1617Checkbox extends PureComponent {
    static propTypes = {
        user: PropTypes.instanceOf(User).isRequired,
        checked: PropTypes.bool,
        disabled: PropTypes.bool,
        flashCheckbox: PropTypes.bool,
        onChange: PropTypes.func,
        openModal: PropTypes.func,
        railcard1617: PropTypes.instanceOf(AccountRailcard),
    };

    static defaultProps = {
        checked: null,
        disabled: false,
        flashCheckbox: false,
        onChange: _.noop,
        openModal: _.noop,
        railcard1617: null,
    };

    componentDidMount() {
        _.defer(() => Railcard1617Actions.load(this.props.user));
    }

    componentDidUpdate({ railcard1617: prevRailcard1617, disabled: prevDisabled }) {
        const { disabled, railcard1617 } = this.props;

        if (prevRailcard1617 && !prevRailcard1617.isPresent() && railcard1617 && railcard1617.isPresent()) {
            _.defer(() => {
                Railcard1617Actions.setChecked(true);
            });
        }

        if (!prevDisabled && disabled) {
            _.defer(() => {
                Railcard1617Actions.setChecked(false);
            });
        }
    }

    handleChange = async () => {
        const { checked } = this.props;
        Railcard1617Actions.setChecked(!checked);
    }

    renderCustomLabel () {
        return (
            <span>
                <span>{ t('season.options.labels.railcard1617') }</span>
                <HelpIcon buttonClassName="railcard1617__help-icon"
                          icon={ 'info' }
                          heading={ t('help.railcard1617.title') }
                          body={ <section className="text-center">
                              <Icon icon="info margin-top margin-bottom otrl-xl" />
                              <div className="text-left">
                                <FormattedHTMLMessage message="help.railcard1617.message" railcard1617WebsiteUrl={ config.get('railcard1617WebsiteUrl') } />
                              </div>
                            </section> }
                />
            </span>
        );
    }

    render() {
        const { checked, disabled, flashCheckbox, openModal, railcard1617 } = this.props;

        const existingRailcard = railcard1617 && railcard1617.isPresent();

        const onClick = e => {
            if (disabled) {
                return false;
            }

            if (!existingRailcard) {
                openModal();
            }
        };

        return (<ToggleInput name="railcard1617"
                    checked={ checked && !disabled }
                    disabled={ disabled }
                    labelClassName={ classnames( 'railcard1617', { 'railcard1617--flashing': flashCheckbox }) }
                    label={ this.renderCustomLabel() }
                    ariaLabel={ t('season.options.labels.railcard1617') }
                    value="railcard1617"
                    onChange={ this.handleChange }
                    onClick={ onClick }
                    srOnly={ t('season.options.labels.railcard1617') }
                    onChangeOverride= { existingRailcard ? null : _.noop }
        />);
    }
}

export default connectToStores([Railcard1617Store], getStateFromStores)(Railcard1617Checkbox);



// WEBPACK FOOTER //
// ./src/components/seasonTicket/Railcard1617Checkbox.js